import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=6d38cfa5&"
import script from "./CompanyInfo.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports